<template>
  <div id="welcome" class="page-bg" :style="{ backgroundImage: 'url(' + $store.getters.getData.background_admin + ')' }">

    <div class="w-logo valign-wrapper">
      <div style="width: 100%">
      <div class="row">
        <div class="col s12 m6 l4 offset-m3 offset-l4">
          <img class="responsive-img" :src="$store.getters.getData.logo_mono">
        </div>
      </div>
      </div>
    </div>

    <div v-if="platform === 'browser'" class="wrapper-btn">
      <a v-on:click="login" v-on:keyup.enter="login" class="waves-effect waves-light btn-large focusable" tabindex="-1">{{$t("WELCOME.LOGIN")}}</a>
      <a class="waves-effect waves-light btn-large focusable" :href="url">{{$t("WELCOME.REGISTER")}}</a>
    </div>
    <div v-else class="wrapper-btn">
      <a v-on:click="login" v-on:keyup.enter="login" class="waves-effect waves-light btn-large focusable" tabindex="-1">LOGIN</a>
    </div>
  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import Bus from '@/components/ControlBus'
import { enviroment, platform } from '@/utils/constants'

export default {
  name: 'Welcome',
  data: function () {
    return { platform: platform }
  },
  created: function () {
    if (!this.$store.getters.getData.is_close || (this.$store.getters.getData.is_close && this.$store.getters.user)) {
      this.$router.push({name: 'content'})
    }
  },
  mounted: function () {
    if (platform !== 'browser') {
      this.SN = SpatialNavigation.add({selector: '#welcome .focusable', restrict: 'self-only'})
      SpatialNavigation.makeFocusable()

      SpatialNavigation.focus(this.SN)
      SpatialNavigation.resume()
    }
    // keys control
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    login: function () {
      (platform === 'browser') ? this.$router.push({name: 'login-browser'}) : this.$router.push({name: 'login-tv'})
    },
    keyBack () {
      if (window.webOS) {
        window.webOS.platformBack() // mostramos bar laucher LG
      } else if (typeof (toast) !== 'undefined') {
        // eslint-disable-next-line
        toast.application.exit()
      }
    }
    // register: function () {
    //   this.$router.push({name: 'register'})
    // }
  },
  computed: {
    url: function () {
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/signup/'
      // return '#/browser-register'
    },
    styles: function () {
      if (this.$store.getters.getData.background_admin) {
        return {
          backgroundImage: 'url(' + this.$store.getters.getData.background_admin + ')'
        }
      }

      // default
      return {
        backgroundImage: `url(${require('@/assets/images/splash.jpg')})`
      }
    }
  },
  beforeDestroy: function () {
    if (this.SN) SpatialNavigation.remove(this.SN)
    Bus.$off('key-back', this.keyBack)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#welcome
  // background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .9)) , url('../../assets/images/splash.jpg')

  background-color: #000
  background-position: center center
  background-repeat: no-repeat
  background-size: cover

  &:before
    content: ''
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    z-index: -1

    background: rgba(0,0,0,.5);
    background-image: linear-gradient(0deg,rgba(0,0,0,0) 50%,rgba(0,0,0,.5) 100%),radial-gradient(50% 120%,rgba(0,0,0,0) 50%,rgba(0,0,0,.7) 100%)

  .wrapper-btn
    position: absolute
    right: 0
    bottom: 0
    // width: 25vw
    margin: 0 2rem 2rem 2rem

    a
      width: 100%

    a:first-child
      margin-bottom: 10px

.w-logo
  position: absolute
  width: 100%
  min-height: 100%

@media (max-width: 768px)
  .wrapper-btn
    margin-bottom: 8rem!important

</style>



// WEBPACK FOOTER //
// src/pages/site/Welcome.vue